export default __webpack_public_path__ + "static/media/back-img.ffc9ffe8.jpg";